var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(item){return _c('p',{key:item.id},[_vm._v(_vm._s(item.id))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }